import {useRef, useState} from 'react';

import {Button} from 'shells/button/button';

import {addNotification} from '../../../notifications/index';

interface BaseAddLeadButtonProps {
    onSubmit: () => Promise<void>;
    errorMessage?: string;
}

export function BaseAddLeadButton(props: BaseAddLeadButtonProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const buttonRef = useRef<HTMLElement | null>(null);

    const handleSubmit = async () => {
        setIsSaving(true);
        try {
            await props.onSubmit();
        } catch {
            addNotification('', {
                body:
                    props.errorMessage ??
                    'An error occurred while creating lead. Please try again later.',
                icon: 'frowny',
            });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Button
            variant='primary'
            getButtonRef={buttonRef}
            onClick={handleSubmit}
            disabled={isSaving}
        >
            + Create lead
        </Button>
    );
}
